import type { FC } from 'react';
import { css } from '@styled-system/css';

export const SensitiveFlag: FC = () => (
  <span
    className={css({
      fontSize: '9px',
      lineHeight: '12px',
      padding: '2px 6px',
      border: '1px solid token(colors.separator)',
      textShadow: '0px 0px 1px token(colors.separator)',
      borderRadius: '4px',
      color: 'content_tertiary',
      fontWeight: '500',
    })}
  >
    センシティブ
  </span>
);
